var exports = {
  "M6": "x43aef4ae--5c4b1b--slide",
  "Uw": "x43aef4ae--5c4b1b--slide-content",
  "h_": "x43aef4ae--5c4b1b--description",
  "Sl": "x43aef4ae--5c4b1b--image",
};

module.exports = exports;
